import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
   this.init_events();
  };


  init_events() {
    let element = document.querySelector(".count-directory-item span");
    element.addEventListener("click", () => {
      let directoryItems = document.querySelectorAll(".directory-card");

      directoryItems.forEach(item => {
        item.classList.remove("hidden");
      })

      element.parentElement.classList.add("hidden")
    });
  };
}
